import { itemList } from '../LifeFaqDetailsPage';
import React, { useState } from 'react';
import { List } from 'antd';
import { Markdown } from 'components';
import styled from 'styled-components';
import close from 'assets/images/arrow-close.svg';
import open from 'assets/images/arrow-open.svg';
import '../LifeFaqDetailsPage.less';
import { useTranslation } from 'react-i18next';

interface FaqlistProps {
  data: {
    title: string;
    list: itemList[]; // 假设 list 是任意类型的数组A
    listzh: itemList[];
  };
}

const Faqtilte = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`;
const FaqQandA = styled.span`
  margin-right: 10px;
`;

export const Faqlist: React.FC<FaqlistProps> = ({ data }) => {
  const [extend, setExtend] = useState<{ [key: string]: boolean }>({});
  const { t, i18n } = useTranslation();

  return (
    <div style={{ background: 'white', width: '672px' }}>
      <div className="header2">
        <div className="headertittle"> {t(data.title)}</div>
      </div>
      <List
        style={{ background: '#fff', maxWidth: '672px' }}
        size="large"
        className="liststyle"
        bordered
        dataSource={i18n.language == 'en' ? data.list : data.listzh}
        renderItem={(item, index) => (
          <List.Item
            style={{ fontFamily: 'Roboto400', display: 'block', backgroundColor: 'white', cursor: 'pointer' }}
            onClick={() => {
              setExtend((prevState) => ({
                ...prevState,
                [index]: !prevState[index],
              }));
            }}
          >
            <div
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '0 10px' }}
            >
              <Faqtilte>
                <FaqQandA>{t('life.questions.q')}</FaqQandA>
                <div>
                  <Markdown>{item.question}</Markdown>
                </div>
              </Faqtilte>
              <img src={extend[index] ? open : close} style={{ marginTop: '6px' }} />
            </div>
            {extend[index] && (
              <div style={{ backgroundColor: '#EBEBEB', padding: '10px' }}>
                <Faqtilte>
                  <FaqQandA>{t('life.questions.a')}</FaqQandA>
                  <div className="Markdownstyle">
                    <Markdown>{item.answer}</Markdown>
                  </div>
                </Faqtilte>
              </div>
            )}
          </List.Item>
        )}
      />
    </div>
  );
};
